import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";

// ------------------ COMPONENTES DE BASE--------------------------
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import Card from "../../../Base/Components/Card/Card";
import { toastShow } from "../../../Base/Services/ToastService";
import { getLabel } from "../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../Base/Context/ConfigContext/ConfigContext";
import { getDatesProduccion } from "../../../Base/Services/Moment/Luxon";
import { setTitlePage } from "../../../Base/Services/Config/ConfigService";
import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";
import CalendarioOperativo from "../../../Base/Components/Form/CalendarioOperativo";

// ------------------- CONSULTAS A LA API---------------------------
import { agregarConstruccionDevoluciones, agregarCuentaDevoluciones, ObtDevolucionesInternas, revisarDevolucionesFin } from "../../../API/Suministros/Devoluciones/DevolucionesInternasRequest";
import { getCuentasHijosQuick } from "../../../API/Finanzas/RegistroContable/RegistroContableRequest";
import { getConstruccionesConcatenadas } from "../../../API/Global/Construcciones/ConstruccionesRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import SalidasCRUD from "./SalidasCRUD";
import RequisaMaterialCrud from "../../ERP/Suministros/Bodegas/RequisasMateriales/RequisasMaterialesCRUD/RequisaMaterialCrud";


const DevolucionesScreen = () => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const [listadoDev, setListadoDev] = useState([]);
  const [dates, setDates] = useState([new Date(), new Date()]);
  const [showDialogSalida, setShowDialogSalida] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);  
  const [habilitar, setHabilitar] = useState(true);
  const [hiddenPriceColumn, setHiddenPriceColumn] = useState(userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(29));
  const [construcciones, setConstrucciones] = useState([]);
  const [cuentas, setCuentas] = useState([]);
  const [showDialogRM, setShowDialogRM] = useState(false);
  const [showRequisa, setShowRequisa] = useState(false);
  

  const getInfo = async () => {
    if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
      toastShow(toast, "warn", "Advertencia", "Por favor, seleccione un rango de fechas válido.");
      return;
    }
    setSelected([])
    setLoading(true);
    const construccionesTempo = await getConstruccionesConcatenadas()
    setConstrucciones(construccionesTempo)
    const cuentasTempo = await getCuentasHijosQuick()
    setCuentas(cuentasTempo)
    const fechas = getDatesProduccion(dates);
    const det = await ObtDevolucionesInternas(fechas)
    setListadoDev(det) 
    setLoading(false);
  };

  const TemplateConstruccion = ({ data, oldValue, api }, column) => {
    return (
      <Dropdown
        value={data?.IdSubConstruccion}
        options={construcciones}
        optionValue="IdSubConstruccion"
        optionLabel="NombreCompuesto"
        filter
        filterBy="NombreCompuesto"
        style={{ width: "100%" }}
        onChange={(e) => {
          let ConstruccionSeleccionda = construcciones.filter(i => i?.IdSubConstruccion === e?.value);
          let changes = [];
          let mensaje = "";

          if (selected.length > 0) {
            const revisados = selected.filter(item => item?.IdEstadoFinanzas === 114);
            if (revisados.length > 0) {
              toastShow(toast, 'error', 'Error', 'Una o más salidas ya están revisadas, no puede eliminar la construcción.');
              return;
            }

            changes = selected.map((item) => {
              return {
                IdDevolucionDetalle: item.IdDevolucionDetalle,
                IdConstruccion: ConstruccionSeleccionda[0]?.IdConstruccion,
                IdSubConstruccion: ConstruccionSeleccionda[0]?.IdSubConstruccion,
                NombreCompuesto: ConstruccionSeleccionda[0]?.NombreCompuesto,
                IdEstadoFinanzas: item?.IdEstadoFinanzas,
              };
            });
          } else {
            if (data?.IdEstadoFinanzas === 114) {
              toastShow(toast, 'error', 'Error', 'La salida ya está revisada, no puede eliminar la construcción.');
              return;
            }

            changes.push({
              IdDevolucionDetalle: data.IdDevolucionDetalle,
              IdConstruccion: ConstruccionSeleccionda[0]?.IdConstruccion,
              IdSubConstruccion: ConstruccionSeleccionda[0]?.IdSubConstruccion,
              NombreCompuesto: ConstruccionSeleccionda[0]?.NombreCompuesto,
              IdEstadoFinanzas: data?.IdEstadoFinanzas,
            });
          }

          if (!ConstruccionSeleccionda[0]) {
            mensaje = `¿Está seguro de eliminar la construcción a ${changes.length} devoluciones?`;
          } else {
            mensaje = <>¿Agregar construcción <strong>{ConstruccionSeleccionda[0]?.NombreCompuesto}</strong> a {changes.length} devoluciones?</>;
          }

          confirmDialog({
            message: mensaje,
            header: "Confirmación",
            icon: "pi pi-exclamation-triangle",
            accept: async () => {
              let IdDevolucionDetalle = changes.map((item) => item.IdDevolucionDetalle);
              let IdSubConstruccion = ConstruccionSeleccionda[0]?.IdSubConstruccion;

              let data = {
                IdDevoluciones: IdDevolucionDetalle.toString(','),
                IdConstruccion: ConstruccionSeleccionda[0]?.IdConstruccion,
                IdSubConstruccion: IdSubConstruccion,
                IdUserEdit: userAuth?.IdUser,
              };

              const resp = await agregarConstruccionDevoluciones(data);
              toastShow(toast, 'success', 'Agregada', 'Construcción agregada');
              getInfo();
              api.stopEditing();
            },
            reject: () => {},
          });

        }}
        showClear
      />
    );
  };

  const TemplateCuenta = ({ data, oldValue, api }, column) => {
    return (
      <Dropdown
        value={data?.IdAccount}
        options={cuentas}
        optionValue="IdAccount"
        optionLabel="NombreCuenta"
        filter
        filterBy="NombreCuenta"
        style={{ width: "100%" }}
        onChange={(e) => {
          let cuentaSeleccionada = cuentas.filter(i => i?.IdAccount === e?.value);
          let changes = [];
          let mensaje = "";

          if (selected.length > 0) {
            const revisados = selected.filter(item => item?.IdEstadoFinanzas === 114);
            if (revisados.length > 0) {
              toastShow(toast, 'error', 'Error', 'Una o más devoluciones ya están revisadas, no puede eliminar la construcción.');
              return;
            }

            changes = selected.map((item) => {
              return {
                IdDevolucionDetalle: item.IdDevolucionDetalle,
                IdAccount: cuentaSeleccionada[0]?.IdAccount,
                NombreCuenta: cuentaSeleccionada[0]?.NombreCuenta,
                IdEstadoFinanzas: item?.IdEstadoFinanzas,
              };
            });
          } else {
            if (data?.IdEstadoFinanzas === 114) {
              toastShow(toast, 'error', 'Error', 'La devolución ya está revisada, no puede eliminar la construcción.');
              return; 
            }

            changes.push({
              IdDevolucionDetalle: data.IdDevolucionDetalle,
              IdAccount: cuentaSeleccionada[0]?.IdAccount,
              NombreCuenta: cuentaSeleccionada[0]?.NombreCuenta,
              IdEstadoFinanzas: data?.IdEstadoFinanzas,
            });
          }
          if (!cuentaSeleccionada[0]) {
            mensaje = `¿Está seguro de eliminar la cuenta a ${changes.length} devoluciones?`;
          } else {
            mensaje = <>¿Agregar cuenta <strong>{cuentaSeleccionada[0]?.NombreCuenta}</strong> a {changes.length} devoluciones?</>;
          }

          confirmDialog({
            message: mensaje,
            header: "Confirmación",
            icon: "pi pi-exclamation-triangle",
            accept: async () => {
              let IdDevolucionDetalles = changes.map((item) => item.IdDevolucionDetalle);

              let data = {
                IdDevoluciones: IdDevolucionDetalles.toString(','),
                IdAccount: cuentaSeleccionada[0]?.IdAccount,
                IdUserEdit: userAuth?.IdUser,
              };

              const resp = await agregarCuentaDevoluciones(data);
              toastShow(toast, 'success', 'Agregada', 'Cuenta agregada correctamente');
              getInfo();
              api.stopEditing();
            },
            reject: () => {},
          });

        }}
        showClear
      />
    );
  };

  const RevisarFinanzas = async (rowData) => {
    const dataToProcess = selected?.length > 1 ? selected : [rowData];
    const notRevisados = dataToProcess.filter(item => !item?.Revisado);
    if (notRevisados.length === 0) {
      confirmDialog({
      message: `¿Está seguro quitar el revisado a ${dataToProcess?.length} ${dataToProcess?.length > 1 ? 'devoluciones' : 'devolución'}?`,
      header: "Confirmación",
      icon: "pi pi-exclamation-triangle",
      accept: async () => {
        const IdDevoluciones = dataToProcess.map(i => i?.IdDevolucionDetalle);
        const dataEnviar = {
          IdDevoluciones: IdDevoluciones.join(','),
          IdUserRevisoFin: null,
          Revisado: false,
        };
        const resp = await revisarDevolucionesFin(dataEnviar)
        toastShow(toast, 'success', 'Revisada', 'Devolución Revisada correctamente');
        getInfo();
      },
      reject: () => {},
    });
      return;
    }

    const invalidItems = notRevisados.filter(item => !item?.IdAccount || !item?.IdConstruccion);
    if (invalidItems.length > 0) {
      toastShow(toast, 'error', 'Error', 'Solo se pueden revisar devoluciones con Cuenta Contable y Construcción asignadas.');
      return;
    }


    confirmDialog({
      message: `¿Está seguro de revisar ${notRevisados?.length} ${notRevisados?.length > 1 ? 'salidas' : 'salida'}?`,
      header: "Confirmación",
      icon: "pi pi-exclamation-triangle",
      accept: async () => {
        const IdSalidas = notRevisados.map(i => i?.IdDevolucionDetalle);
        const dataEnviar = {
          IdDevoluciones: IdSalidas.join(','),
          IdUserRevisoFin: userAuth?.IdUser,
          Revisado: true,
        };

        const resp = await revisarDevolucionesFin(dataEnviar)
        toastShow(toast, 'success', 'Revisada', 'Devolució Revisada correctamente');
        getInfo();
      },
      reject: () => {},
    });

  };

  const columns = [
    {
      field: "IdDevolucionDetalle",
      header: "ID",
      headerEn: "ID",
      frozen: "frozen",
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      field: "FechaDevolucion",
      header: "Fecha Devolucion",
      headerEn: "Date Returns",
      frozen: "frozen",
      className: "small",
      Format:'DateTime2'
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "StatusName",
      frozen: true,
      className: "small",
      Format: "Estado",
      body: (rowData) => ({ ID: rowData.IdEstado, Estado: rowData.StatusName }),
    },
    {
      field: "Requisa",
      header: "Requisa de Material",
      headerEn: "Material Requisition",
      className: "small",
      Format: "Modal",
      frozen: true,
      align: "center",
      onCellDoubleClicked: ({ data }) => {
        Requisa(data.Requisa);
      },
      Sumary: 'count',
    },
    {
      field: "CodigoProducto",
      header: "Codigo",
      headerEn: "Product",
      className: "Xsmall",
    },
    {
      field: "NombreProducto",
      header: "Nombre Producto",
      headerEn: "Product Name",
      className: "Xlarge",
    },
    {
      field: "NombreCompuesto",
      header: "Construcción",
      headerEn: "Construccion",
      editable: true,
      className: "XXXlarge",
      cellEditor: TemplateConstruccion,
    },
    {
      field: "NombreCuenta",
      header: "Cuenta",
      headerEn: "Account",
      className: "XXXlarge",
      editable: habilitar,
      cellEditor: TemplateCuenta,
    },
    {
      field: "DescripcionProducto",
      header: "Descripción",
      headerEn: "Description",
      className: "large",
    },
    {
      field: "NombreCategoria",
      header: "Tipo Producto",
      headerEn: "Product Type",
      className: "small",
    },
    {
      field: "NombreSubcategoria",
      header: "Categoría",
      headerEn: "Category",
      className: "small",
    },
    {
      field: "NombreTipoProducto",
      header: "SubCategoría",
      headerEn: "Sub Category",
      className: "medium",
    },
    {
      field: "QtySalida",
      header: "Despachado",
      headerEn: "Shipped",
      Sumary: "sum",
      className: "small",
      Format: "Currency",
    },
    // LEMPIRAS
    {
      headerName: "Lempiras",
      children: [
        {
          header: "Precio L",
          headerEn: "Price L",
          field: "PrecioL",
          hidden: hiddenPriceColumn,
          Format: "Currency",
          className: "Xsmall",
        },
        {
          header: "Monto L",
          headerEn: "Amount L",
          field: "MontoL",
          hidden: hiddenPriceColumn,
          Sumary: "sum",
          Format: "Currency",
          className: "Xsmall",
        },
      ],
    },
    // DOLARES
    {
      headerName: "Dolares",
      children: [
        {
          header: "Precio D",
          headerEn: "Price D",
          field: "PrecioD",
          hidden: hiddenPriceColumn,
          Format: "Currency",
          className: "Xsmall",
        },
        {
          header: "Monto D",
          headerEn: "Amount D",
          field: "MontoD",
          hidden: hiddenPriceColumn,
          Sumary: "sum",
          Format: "Currency",
          className: "Xsmall",
        },
      ],
    },
    {
      header: "Estado Finanzas",
      field: "StatusNameFinanzas",
      frozen: true,
      className: "small",
      alignFrozen: "right",
      Format: "Estado",
      body: (rowData) => ({ ID: rowData.IdEstadoFinanzas, Estado: rowData.StatusNameFinanzas }),
    },
    {
      field: "Revisado",
      header: "Revisado",
      className: "Xsmall",
      Format: "Template",
      frozen: "true",
      alignFrozen: "right",
      filter: false,
      body: (rowData) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <Checkbox checked={rowData.Revisado === 1 ? true : false} onClick={() => RevisarFinanzas(rowData)} />
        </div>
      ),
    },
    {
      field: "CantidadDevolucion",
      header: "Cantidad Devuelta",
      headerEn: "Refund Amount",
      Sumary: "sum",
      className: "small",
      Format: "Currency",
      frozen: "true",
      alignFrozen: "right",
    },
  ];

  const table = {
    Columns: columns,
    Data: listadoDev,
    loading: loading,
    selected: selected,
    setSelected: (e) => setSelected(e),
    showModal: (e) => showModal(e),
  };

  const Requisa = (Id) => {
    setShowRequisa(Id);
    showModal();
  };

  const showModal = () => {
    setShowDialogRM(true);
  };

  const cerrarConfirmacion = () => {
    // Mostrar confirmación si hay ediciones sin guardar
    if (habilitar && showRequisa !== null) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setShowDialogRM(null);
          setShowRequisa(null); // Cerrar el diálogo
        },
        rejectLabel: "No",
        reject: () => {}, // No hacer nada si el usuario cancela
        style: { backgroundColor: "white" },
      });
    } else {
      setShowDialogRM(null);
      setShowRequisa(null);
      setHabilitar(true);
    }
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, 'Devoluciones', config.language));
  }, []);

  return (
    <div>
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones flex-wrap">
            <h2>{getLabel(baseLang,'Devoluciones', config.language)}</h2>            
            <CalendarioOperativo
              dates={dates}
              setDates={setDates}
              loading={loading}
              getInfo={getInfo}
            />

            <Button
              icon="pi pi-refresh"
              tooltip="Buscar"
              onClick={() => getInfo()}
            />
          </div>
        }
        contenido={
          <div className="p-4 mt-2" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />

      {showDialogSalida && (
        <SalidasCRUD
          showDialog={showDialogSalida}
          setShowDialog={setShowDialogSalida}
          selected={selected}
          setSelected={setSelected}
          habilitar={habilitar}
          setHabilitar={setHabilitar}
        />
      )}

      <Dialog
        visible={showDialogRM}
        onHide={() => {
          cerrarConfirmacion();
        }}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
      >
        <RequisaMaterialCrud
          idIngreso={showRequisa}
          setIngresoToShow={setShowRequisa}
          showDialog={showDialogRM}
          // actualizarIngresosScreen={actualizarIngresosScreen}
          // setOrderToShow={setOrderToShow}
          // setOrdenDialog={setOrdenDialog}
          habilitar={habilitar}
          setHabilitar={setHabilitar}
          editable={false}
        />
      </Dialog>
    </div>
  );
};

export default DevolucionesScreen;